import { render, staticRenderFns } from "./CReasonCell.vue?vue&type=template&id=4de457fb&scoped=true&"
import script from "./CReasonCell.vue?vue&type=script&lang=ts&"
export * from "./CReasonCell.vue?vue&type=script&lang=ts&"
import style0 from "./CReasonCell.vue?vue&type=style&index=0&id=4de457fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de457fb",
  null
  
)

export default component.exports